import React, { useRef, useState } from 'react';

const SwipeToDelete = ({ onDelete, children, threshold = 80 }) => {
  const [offsetX, setOffsetX] = useState(0);
  const [swiping, setSwiping] = useState(false);
  const startX = useRef(null);

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    setSwiping(true);
  };

  const handleTouchMove = (e) => {
    if (startX.current === null) return;
    const delta = e.touches[0].clientX - startX.current;
    if (delta < 0) setOffsetX(Math.max(delta, -140));
  };

  const handleTouchEnd = () => {
    if (offsetX < -threshold) {
      onDelete();
    }
    setOffsetX(0);
    setSwiping(false);
    startX.current = null;
  };

  return (
    <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '10px', marginBottom: '8px' }}>
      <div style={{
        position: 'absolute', right: 0, top: 0, bottom: 0,
        width: '80px', background: '#e53e3e',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: '10px', zIndex: 0
      }}>
        <span style={{ color: 'white', fontSize: '20px' }}>🗑️</span>
      </div>
      <div
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          transform: `translateX(${offsetX}px)`,
          transition: swiping ? 'none' : 'transform 0.3s ease',
          position: 'relative', zIndex: 1
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default SwipeToDelete;